export default {
  code: 'PO250804000008',
  codeStr: '合同号：PO250804000008',
  type: 'CGDD01_SYS',
  typeName: '标准采购订单',
  purchaseDate: '2025-08-04',
  purchaseDeptName: '',
  purchaseUserName: '杨成伟',
  deliveryWarehouseName: 'YCW测试仓库',
  payMethodName: '预付',
  totalAmount: '110',
  totalAmountStr: '110.00',
  totalNotTaxAmount: '90.16',
  totalNotTaxAmountStr: '90.16',
  totalNotTaxAmountChinese: '人民币壹佰壹拾元整',
  currency: 'CNY',
  supplierAccountName: '111111',
  supplierBankName: '中国工商银行',
  supplierBankNo: '1231231241242134',
  purchaseOrgName: '东莞市简拍智造科技有限公司',
  firstSignDate: '2025-08-04',
  deliveryWarehouseAddress: '深圳市龙岗区001大道',
  deliveryWarehouseContract: '张三',
  deliveryWarehouseTel: '1827388327',
  supplierName: '七七供应商',
  secondSignDate: '2025-08-04',
  supplierAddress: '星河大厦',
  supplierContract: '小胡',
  supplierTel: '15122332211',
  supplierEmail: 'hushuang@ulanzi.cn',
  paymentConditionName: '预付100%货款',
  logoUrl: null,
  printTime: '2025-08-04',
  printName: 'jiaxiaoli',
  tableData: [
    {
      image: 'group1/M00/6C/81/rBBkDGdr-bmABpI3AABedlVUS_w189.jpg',
      skuNo: 'hus252',
      spuNo: 'hus252',
      declareName: '小型相机滤镜白色',
      declareModel: '1245281',
      productName: '小型相机滤镜',
      purchaseQty: 5,
      unitName: '个',
      taxRate: '22',
      price: '18.0328',
      priceStr: '18.0328',
      taxPrice: '22',
      taxPriceStr: '22.0000',
      notTaxPurchaseAmount: '90.16',
      notTaxPurchaseAmountStr: '90.16',
      purchaseAmount: '110',
      purchaseAmountStr: '110.00',
      planDeliveryDate: '2025-08-04',
      remark: '测试',
      isGift: false,
      isGiftStr: '否',
      firstMassProduct: 'firstPilotBatch',
      firstMassProductName: '试产首批',
      isUrgent: false,
      isUrgentStr: '否',
    },
  ],
  tableData: [
    {
      image: 'group1/M00/6C/81/rBBkDGdr-bmABpI3AABedlVUS_w189.jpg',
      skuNo: 'hus252',
      spuNo: 'hus252',
      declareName: '小型相机滤镜白色',
      declareModel: '1245281',
      productName: '小型相机滤镜',
      purchaseQty: 5,
      unitName: '个',
      taxRate: '22',
      price: '18.0328',
      priceStr: '18.0328',
      taxPrice: '22',
      taxPriceStr: '22.0000',
      notTaxPurchaseAmount: '90.16',
      notTaxPurchaseAmountStr: '90.16',
      purchaseAmount: '110',
      purchaseAmountStr: '110.00',
      planDeliveryDate: '2025-08-04',
      remark: '测试',
      isGift: false,
      isGiftStr: '否',
      firstMassProduct: 'firstPilotBatch',
      firstMassProductName: '试产首批',
      isUrgent: false,
      isUrgentStr: '否',
    },
  ],
}
